import React from 'react';

export default ({
  email,
  subscribed,
  onChange,
  onClick,
}) => (
  <>
    <div className="page--banner">
      <a className="page--banner--logo" href="/">
        <img alt="" src="/images/good-cup.svg" />
      </a>
      <h6>#LetsBrewBetter</h6>
    </div>
    <div className="page--header">
      <div className="page--header-index">
        <h3 className="page--header-index-title text-align--center">
          Thank you!
        </h3>
        <p className="page--header-index-sub text-align--center">
          We’re grateful that you love it. Take a photo of your coffee, share it to the world and <strong>#LetsBrewBetter</strong>
        </p>
        <a className="link -primary" href="/">
          Let's Brew Again
        </a>
      </div>
    </div>
    <div className="page--body">
      <div className="page--body-newsletter">
        <h5>Coming Soon</h5>
        <h3 className="page--body-newsletter-title text-align--center">
          Sign Up For Our Goodcup Coffee Community App
        </h3>
        <div className="page--body-newsletter-app">
          <img alt="" src="/images/app.png" />
        </div>
        <p className="page--body-newsletter-sub text-align--center">
          With over 50 coffee brewing recipes from top baristas to popular crowdsourced concotions made personally by your local coffee community.
        </p>
        <div className="page--footer">
          <div className="page--footer-subscribe">
          {subscribed && (
              <div className="page--footer-subscribe-message">
                <img alt="" src="/images/check.svg" />
                <span className="page--footer-subscribe-message-title">You have subscribed to our newsletter!</span>
              </div>
            )}
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="example@email.com"
                value={email}
                onChange={(evt) => onChange(evt, 'newsletter')}
              />
                <button
                  className="btn page--footer-subscribe-button"
                  type="button"
                  onClick={() => onClick('subscribe')}
                >
                  Submit
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
